import React from 'react';
import { Link } from 'react-router-dom';
import coverImage from '../../img/xray_logo_vert.png';
import Logo from '../../img/fpg_logo.png';
import lonelyHandsCover from '../../img/lhcover.png'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    backgroundColor: '#0a1128', // Deep Midnight Blue
    color: '#f8fafc', // Off-white text for readability
    fontFamily: '"Inter", sans-serif',
  },
  // HERO SECTION
  hero: {
    height: '85vh',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // Swapped the white gradient for a glowing dark blue one
    background: 'radial-gradient(circle at 50% 50%, #15234b 0%, #0a1128 100%)', 
    textAlign: 'center',
    padding: '0 20px',
  },
  heroHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '25px',
    marginBottom: '20px',
    flexWrap: 'wrap',
  },
  heroLogo: {
    height: '100px',
    width: 'auto',
    objectFit: 'contain',
    filter: 'drop-shadow(0 4px 10px rgba(0,0,0,0.5))', // Darkened the shadow
  },
  heroTitle: {
    fontSize: '5rem',
    fontWeight: '900',
    margin: 0,
    letterSpacing: '-2px',
    // Changed the dark grey to white so it pops into the purple
    background: '-webkit-linear-gradient(45deg, #ffffff, #b026ff)', 
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    color: 'transparent',
    lineHeight: '1',
  },
  heroSubtitle: {
    fontSize: '1.5rem',
    color: '#94a3b8', // Light slate-blue/grey
    marginBottom: '50px',
    maxWidth: '650px',
    lineHeight: '1.6',
    fontWeight: '400',
  },
  ctaButton: {
    padding: '18px 50px',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor: '#b026ff', // Signature purple stays!
    border: 'none',
    borderRadius: '50px',
    cursor: 'pointer',
    textDecoration: 'none',
    boxShadow: '0 10px 25px rgba(176, 38, 255, 0.3)',
    transition: 'transform 0.2s, box-shadow 0.2s',
  },
  // PROJECTS SECTION
  section: {
    padding: '100px 20px',
    width: '100%',
    maxWidth: '1200px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  sectionTitle: {
    fontSize: '2.5rem',
    fontWeight: '800',
    marginBottom: '60px',
    color: '#f8fafc', // White
    position: 'relative',
  },
  grid: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '40px',
    width: '100%',
  },
  card: {
    backgroundColor: '#162447', // A slightly lighter navy to separate from the background
    borderRadius: '16px',
    overflow: 'hidden',
    width: '380px',
    boxShadow: '0 20px 40px rgba(0,0,0,0.4)', // Darker shadow for depth
    transition: 'transform 0.3s, box-shadow 0.3s',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #2a3b61', // Subtle dark blue border instead of harsh light grey
  },
  cardImage: {
    height: '220px',
    width: '100%',
    objectFit: 'cover',
    borderBottom: '1px solid #2a3b61',
  },
  cardContent: {
    padding: '30px',
    textAlign: 'left',
  },
  cardTitle: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#ffffff', // White
  },
  cardText: {
    color: '#94a3b8', // Light slate-blue/grey
    lineHeight: '1.6',
    marginBottom: '25px',
  },
  textLink: {
    color: '#b026ff', // Signature purple stays!
    fontWeight: 'bold',
    textDecoration: 'none',
    fontSize: '1.1rem',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },
  sectionUnderline: {
    position: 'absolute', bottom: '-15px', left: '50%', transform: 'translateX(-50%)', 
    width: '60px', height: '4px', backgroundColor: '#b026ff', borderRadius: '2px'
  },
  cardHeaderRow: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px'
  },
  badge3X: {
    fontSize: '0.75rem', backgroundColor: 'rgba(255, 0, 127, 0.1)', color: '#ff007f', 
    padding: '4px 8px', borderRadius: '4px', fontWeight: 'bold'
  },
  badgeLonely: {
    fontSize: '0.75rem', backgroundColor: 'rgba(16, 185, 129, 0.1)', color: '#10b981', 
    padding: '4px 8px', borderRadius: '4px', fontWeight: 'bold', border: '1px solid #10b981'
  },
  socialSection: {
    padding: '80px 20px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center',
    backgroundColor: '#111c3a', // Lighter navy to contrast with main background
  },
  socialTitle: {
    fontSize: '2rem', marginBottom: '20px', fontWeight: 'bold', color: '#f8fafc'
  },
  socialText: {
    color: '#94a3b8', marginBottom: '30px', textAlign: 'center' // Slate grey for dark mode
  },
  socialButtonGroup: {
    display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center'
  }
};

export default function HomePage() {
  return (
    <div style={styles.container}>
      
      {/* --- HERO SECTION --- */}
      <div style={styles.hero}>
        <div style={styles.heroHeader}>
          <img src={Logo} style={styles.heroLogo} alt="Logo" />
          <h1 style={styles.heroTitle}>FOREPLAY GAMES</h1>
        </div>
        <p style={styles.heroSubtitle}>
          We build worlds where gameplay meets desire. 
          Narrative-driven, uncensored, and unforgettable.
        </p>
        <Link to="/games/3xr" style={styles.ctaButton}>
          Check out our main project!
        </Link>
      </div>

      {/* --- CURRENT PROJECTS --- */}
      <div style={styles.section}>
        <h2 style={styles.sectionTitle}>
          Current Projects
          <span style={styles.sectionUnderline}/>
        </h2>
        
        <div style={styles.grid}>
          
          {/* CARD 1: 3XRay */}
          <div style={styles.card}>
            <img 
              src={coverImage} 
              alt="3XRay Cover Art" 
              style={styles.cardImage} 
            />
            
            <div style={styles.cardContent}>
              <div style={styles.cardHeaderRow}>
                <h3 style={{ ...styles.cardTitle, margin: 0 }}>3XRay</h3>
                <span style={styles.badge3X}>AI-ASSISTED</span>
              </div>

              <p style={styles.cardText}>
                Use your X-Ray vision to uncover secrets, navigate social hierarchies, and find romance where you least expect it.
              </p>
              
              <Link to="/games/3xr" style={styles.textLink}>
                View Game Page →
              </Link>
            </div>
          </div>

          {/* CARD 2: LonelyHands */}
          <div style={styles.card}>
            <img 
              src={lonelyHandsCover} 
              alt="LonelyHands Cover Art" 
              style={styles.cardImage} 
            />
            
            <div style={styles.cardContent}>
              <div style={styles.cardHeaderRow}>
                <h3 style={{ ...styles.cardTitle, margin: 0 }}>LonelyHands</h3>
                <span style={styles.badgeLonely}>NO AI</span>
              </div>

              <p style={styles.cardText}>
                A minimalist, pixel-art desktop simulator. Pay your tuition by ghostwriting for top models on a subscription platform, balancing your digital hustle with your real life.
              </p>
              
              <Link to="/games/lonelyhands" style={styles.textLink}>
                View Game Page →
              </Link>
            </div>
          </div>

        </div>
      </div>

      {/* --- NEWSLETTER / SOCIALS --- */}
      <div style={styles.socialSection}>
        <h2 style={styles.socialTitle}>Join The Community</h2>
        <p style={styles.socialText}>
          Get exclusive sketches, devlogs, and early builds.
        </p>
        
        <div style={styles.socialButtonGroup}>
           
           {/* TWITTER / X */}
           <a 
             href="https://x.com/ForeplayGames" 
             target="_blank" 
             rel="noopener noreferrer"
             style={{...styles.ctaButton, backgroundColor: '#1da1f2', fontSize: '1rem'}} // Twitter Blue instead of Black so it pops on dark mode
           >
             Twitter / X
           </a>

           {/* DISCORD */}
           <button 
             style={{...styles.ctaButton, backgroundColor: '#5865F2', fontSize: '1rem', cursor: 'not-allowed', opacity: 0.7}}
             title="Discord Community Opening Soon!"
           >
             Discord (Coming Soon)
           </button>

        </div>
      </div>

    </div>
  );
}